import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProviderAvailabilityResponseItem, ProviderSessionAvailability } from '../../interfaces/provider-seession-avaliability';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ProviderManagementService } from 'src/app/modules/provider-management/services/provider-management.service';
import { LoadingService } from 'src/app/services/loading.service';
import { AuthStore } from 'src/app/stores/auth.store';
import { SchedulerEditService } from '../../services/scheduler-edit.service';
import { User } from '../../models/user';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { ScheduleDetailsComponent } from '../schedule-details/schedule-details.component';
import { formatStartToAPI } from 'src/app/modules/administration/constants/scheduler';
import { MANDATE_STATUS } from 'src/app/modules/provider-management/constants/mandates-status.constants';
import { showAvailabilityNotification } from '../../functions/availability-notification';

@Component({
  selector: 'app-schedule-error-dailogbox',
  templateUrl: './schedule-error-dailogbox.component.html',
  styleUrl: './schedule-error-dailogbox.component.scss',
  standalone: false,
})
export class ScheduleErrorDailogboxComponent implements OnInit {
  readonly padStartLength: number = 2;
  @Output() dialogClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() getScheduleDetailsFormGroup: FormGroup;
  @Input() public scheduleDetailsCmp: ScheduleDetailsComponent;
  @Input() isEditingSession: boolean;
  @Input() public isNew: boolean
  public user: User;
  @Output() dialogClosed: EventEmitter<boolean> = new EventEmitter<boolean>();
  public payload: ProviderSessionAvailability;
  public gridData: { issueType: string; descriptionType: string; description?: Record<string, boolean> }[] = [];
  constructor(public scheduleEditService: SchedulerEditService,
    private providerManagementService: ProviderManagementService,
    private notificationService: NotificationService,
    private loadingService: LoadingService,
    private dialog: DialogRef,
    private authStore: AuthStore) {
    this.user = this.authStore.UserInfo;
  }
  public closeDialog(): void {
    this.dialogClose.emit();
  }
 
  @HostListener('keydown', ['$event'])
  stopParentDialogKeyboardHandling(event: KeyboardEvent): void {
    if (event.key === 'Tab' || event.key === 'Escape') {
      event.stopPropagation();
    }
  }
 
  ngOnInit(): void {
    const selectedMandates = this.getScheduleDetailsFormGroup?.value?.studentMandates ?? [];
    const allPendingOrAwaiting =selectedMandates.length > 0 && selectedMandates.every(m => m.status === MANDATE_STATUS.pendingScheduling || m.status === MANDATE_STATUS.awaitingFirstAttend);

    const hasNoMandates = selectedMandates.length === 0;
    const hasAnyMismatch =
      this.scheduleDetailsCmp?.checkValidLanguages === false ||
      this.scheduleDetailsCmp?.checkValidDuration === false ||
      this.scheduleDetailsCmp?.checkValidServiceTypes === false ||
      this.scheduleDetailsCmp?.checkGroupeSize === false ||
      this.scheduleDetailsCmp?.checkValidGradeorAge === false ||
      this.scheduleDetailsCmp?.checkValidServiceStartDate === false ||
      (this.scheduleDetailsCmp?.showEndData
    ? this.scheduleDetailsCmp?.checkAssignmentEndDate === false
    : false);
      this.gridData = [];

    if (hasNoMandates) {
      this.gridData.push({
        issueType: 'Error',
        descriptionType: 'error',
        description: { noMandates: true }
      });
    }
    if (hasAnyMismatch) {
      this.gridData.push({
        issueType: 'Warning',
        descriptionType: 'detailed',
        description: {
          lanaguage: this.scheduleDetailsCmp?.checkValidLanguages,
          duration: this.scheduleDetailsCmp?.checkValidDuration,
          serviceType: this.scheduleDetailsCmp?.checkValidServiceTypes,
          size: this.scheduleDetailsCmp?.checkGroupeSize,
          startDate: this.scheduleDetailsCmp?.checkValidServiceStartDate,
          endDate: this.scheduleDetailsCmp?.checkAssignmentEndDate,
          gradeOrAge: this.scheduleDetailsCmp?.checkValidGradeorAge
        }
      });
    }
    this.gridData.push({
      issueType: 'Warning',
      descriptionType: 'simple',
    });
    if (hasNoMandates || allPendingOrAwaiting) {
      this.gridData = this.gridData.filter(item => item.descriptionType !== 'simple');
    }

  }
  get isScheduleDisabled(): boolean {
    return this.gridData?.some(item =>
      item.issueType === 'Error'
    );
  }
  saveScheduler(): void {

    this.payload = new ProviderSessionAvailability({
      ...this.getScheduleDetailsFormGroup?.value,
      providerSK: this.user?.providerSk,
      startTime: this.formatTo24HourTime(this.getScheduleDetailsFormGroup?.value?.startTime),
      endTime: this.formatTo24HourTime(this.getScheduleDetailsFormGroup?.value?.endTime),
      daysOfWeek: this.formatWeekDays(this.getScheduleDetailsFormGroup?.value?.weekDayChip),
      isEditingSession: this.isEditingSession,
      details: this.scheduleDetailsCmp.meetingDetails,
      meetingSk: this.scheduleDetailsCmp?.meetingSk,
      isAdd: this.isNew ? true : false

    });
    if (!this.isNew) {
      this.payload.canceledDate = formatStartToAPI(this.scheduleDetailsCmp?.startDate);
    }

    this.loadingService.show();
    this.providerManagementService.GetProviderSessionAvailability(this.payload).subscribe((data: ProviderAvailabilityResponseItem[]) => {
      if (this.isAllAvailable(data)) {
        this.loadingService.hide();
        this.dialogClosed.emit(true);
      } else {
        showAvailabilityNotification(data, this.notificationService);
        this.loadingService.hide();
        this.dialogClosed.emit(false);
      }

    })
  }

  formatWeekDays(days: number[]): string {
    const WEEKDAY_MAP: Record<number, string> = {
      1: 'MON',
      2: 'TUE',
      3: 'WED',
      4: 'THU',
      5: 'FRI',
      6: 'SAT',
      7: 'SUN'
    };
    if (!Array.isArray(days)) return '';

    return days
      .map((d: number) => WEEKDAY_MAP[d])
      .filter(Boolean)
      .join(', ');
  }
  formatTo24HourTime(isoString: string): string {
    if (!isoString) return '';

    const date: Date = new Date(isoString);

    const hours: string = date.getHours().toString().padStart(this.padStartLength, '0');
    const minutes: string = date.getMinutes().toString().padStart(this.padStartLength, '0');

    return `${hours}:${minutes}`;
  }

  public isAllAvailable(data: { availability: string }[]): boolean {
    return data.every(
      (item: { availability: string }) => item.availability.trim() === 'Available'
    );
  }
  closeDialogBox(isConfirmed: boolean): void {
    this.dialogClosed.emit(isConfirmed);
  }

}
